@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

.section {
	background-color: Colors.$col-white;
	margin-bottom: Constants.$val-spacing-m;
	padding: Constants.$val-spacing-m;
	border-bottom: 1px solid Colors.$col-greyConnection;
}

.container {
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-s;
}


.timestamp {
	display: flex;
	flex-direction: column;
	align-items: center;
	align-items: flex-start;
	margin-bottom: Constants.$val-spacing-s;


	&__label {
		font-weight: 700;
	}
}

.field-value {
	margin: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-l;
	display: flex;
	flex-direction: row;
	gap: 5px;
}

.title {
	font-size: Constants.$val-fontSizeXBig;
	font-weight: bold;
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
}

.tool-type {
	color: Colors.$col-design-grey15;
}

.section-title {
	color: Colors.$col-grey;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeBig;
	display: flex;
	flex-direction: column;
	margin-bottom: Constants.$val-spacing-m;
}
.valid-cell-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 5px;
}

.grey-text {
	color: Colors.$col-greyFontLight;
}

.date-value {
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-design-grey15;
}

.total-cost-container {
	background-color: Colors.$col-greyBackground;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: end;
	font-weight: bold;
	padding-right: Constants.$val-spacing-m;
	padding-top: Constants.$val-spacing-l;
	padding-bottom: - Constants.$val-spacing-xl;
	height: 55px;
}

.buttons {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	justify-content: flex-end;
}

.field-row {
	margin-bottom: Constants.$val-spacing-l;
	margin-top: Constants.$val-spacing-l;
}

.table-text {
	font-size: Constants.$val-fontSizeRegular;
}